import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'

// Components
import Flag from './flag'

function truncateString(str, num) {
  if (str.length <= num) {
    return str
  }
  return str.slice(0, num) + '...'
}

const ProductCard = ({ auctionUuid, hit, type }) => {
  const { image } = hit
  const auctionUrl = `/auction/#!/auctions/${auctionUuid}/`
  const itemUrl = `${auctionUrl}listings/${hit.objectID || hit.uuid}/`
  return (
    <div className='flex flex-col h-full gap-4 bg-white rounded-md shadow'>
      <div className='relative flex aspect-video flex-col items-center justify-center h-80'>
        {image ? (
          <a href={itemUrl}>
            <img className='max-h-80 w-auto' loading='lazy' src={`${image.basePath}${image.versionAndPublicId}`} alt={hit.name} />
          </a>
        ) : (
          <div className='w-full flex flex-col items-center justify-center gap-3'>
            <StaticImage src='../images/Apex-Auctions_Icon.png' className='grayscale opacity-10' alt='Image not available' layout='fixed' width={100} />
            <div className='text-gray-400'>Image not available</div>
          </div>
        )}
        {hit.countryCode && (
          <span className='absolute left-0 bottom-5 inline-flex items-center rounded-r-sm bg-blue-50 px-2 py-1 gap-1 text-sm font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10'>
            <Flag lang={hit.countryCode} className='m-0' /> {hit.lotNumber && <span>LOT {hit.lotNumber}</span>}
          </span>
        )}
      </div>
      <div className='flex flex-col items-start gap-4 flex-1 p-4'>
        {hit.title && (
          <a className='text-xl' href={itemUrl}>
            {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
            <span dangerouslySetInnerHTML={{ __html: hit.title }} />
          </a>
        )}
        {hit.summary && <div dangerouslySetInnerHTML={{ __html: truncateString(hit.summary, 240) }} />}
        {type === 'pastAuction' ? (
          <div className='bg-slate-100 p-4 mt-auto w-full text-center'>Sale has ended</div>
        ) : (
          <div className='flex gap-2 mt-auto w-full'>
            <a className='button button-ghost flex-1 text-center' href={auctionUrl}>
              View Auction
            </a>
            <a className='button button-primary flex-1 text-center' href={itemUrl}>
              View Item
            </a>
          </div>
        )}
      </div>
    </div>
  )
}
export default ProductCard
